<div class="custom-container">
    <img
        class="logo mt-5 mx-auto d-block"
        ngSrc="assets/images/sprintpay-horizontal-logo.svg"
        alt="Cargo Sprint Logo"
        width="270"
        height="60"
    />

    @if (state === 'email') {
        <div class="header text-center">
            @if (fileType === 'W9_FILE') {
                Payee Application W9 form
            }
            @if (fileType === 'VOID_CHECK_FILE') {
                Payee Application Bank Letter
            }
        </div>
        <div class="header-description">
            To proceed with updating the document, please complete the additional security layer. This step is essential
            to ensure the integrity and security of the document.
        </div>
        @if (emailForm.controls['email'].value) {
            <form [formGroup]="emailForm" class="w-100 form-container">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input id="email" matInput formControlName="email" placeholder="john.doe@example.com" />
                    <mat-error>
                        <app-invalid-field [field]="'email'" [messageList]="errorList" />
                    </mat-error>
                </mat-form-field>
                <button
                    id="validate-email"
                    class="btn__sprintpay btn__sprintpay--green send-button"
                    color="primary"
                    type="button"
                    mat-button
                    (click)="validateEmail()"
                >
                    SEND
                </button>
            </form>
        }
    }
    @if (state === 'upload') {
        <div class="text-center">
            <div class="header text-center pb-4">
                @if (fileType === 'W9_FILE') {
                    Please upload your W9 document
                }
                @if (fileType === 'VOID_CHECK_FILE') {
                    Please upload your Bank Letter document
                }
            </div>
            <div class="w-100">
                <lib-file-upload
                    class="file-upload"
                    #w9FileUpload
                    id="w9-upload"
                    fieldName="fileUpload"
                    [whiteListFile]="filesWhiteList"
                    (filesAdded)="filesAdded($event)"
                    [loading]="uploading"
                    [isDisabled]="false"
                    [isRequired]="true"
                    [title]="fileType === 'W9_FILE' ? titleW9 : titleBankLetter"
                    [subtitle]="subtitle"
                    [maxFilesAllowed]="1"
                    [errorMessage]="'Maximum of 1 file allowed'"
                />
                <lib-file-remover #fileRemover class="mt-2" [fieldName]="'fileUpload'" />
            </div>
            <div class="d-flex justify-content-center pt-4">
                <button
                    id="upload-document"
                    class="btn__sprintpay btn__sprintpay--green send-button"
                    color="primary"
                    type="button"
                    mat-button
                    [disabled]="!fileToUpload"
                    (click)="uploadDocument()"
                >
                    SUBMIT
                </button>
            </div>
        </div>
    }
    @if (state === 'completed') {
        <div class="d-flex justify-content-center mt-4">
            <img ngSrc="assets/images/icons/icon-success.svg" alt="success" width="92" height="92" />
        </div>
        <div class="successful text-center mt-4">Upload Successful!</div>
        <div class="header-description">
            You have successfully completed the upload process. You can now leave this page or visit the CargoSprint
            website.
        </div>
        <div class="d-flex justify-content-center mt-4">
            <button
                id="navigate-to-cargosprint"
                class="btn__sprintpay btn__sprintpay--green send-button go-to-cargosprint"
                color="primary"
                type="button"
                mat-button
                (click)="navigateToCargosprint()"
            >
                GO TO CARGOSPRINT
            </button>
        </div>
    }
</div>

<ng-template #twoFactorModal>
    <app-two-factor [module]="module" />
</ng-template>
